import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import './index.scss'
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal, Card, Row, Col, Button} from "antd";
import {gepselectmap} from "../../../../utils/gepdatadef"
import {getStorage} from "@/utils";
import {
  refreshMenu,
} from "../../../../redux/common/action";
import {savebaseingo,getbaseInfo} from "../../../../servers/menuAPI";
import CInput from "../../../../components/CForm/CInput";
import CRadio from "../../../../components/CForm/CRadio";
import CSelect from "../../../../components/CForm/CSelect";
import CDatePicker from "../../../../components/CForm/CDatePicker";
import store from "../../../../redux";
import {selectPicDetail} from "../../../../servers/menu";
@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.inputChange = this.inputChange.bind(this)
  }

  state = {
    optionlist:[
      {name:'国有',value:'国有'},
      {name:'非国有',value:'非国有'},
    ],
    options:gepselectmap['1B'],
    tcoptions:gepselectmap['17'],
    froptions:gepselectmap['1C'],
    data:  {
      annuals:[],
      name:'',
      district:'',
      nature:'',
      applylevel:'',
      level:'',
      createdate:'',
      holder:'',
      authority:'',
      funds:'',
      belonglevelid:'',
      subjectid:'',
      corporateid:'',
      regauthority:'',
      firstdate:'',
      postaddress:'',
      postcode:'',
      officephone:'',
      fax:'',
      url:'',
      newmedia:'',
      legalmanname:'',
      legalmansex:'',
      levelingtime:'',
      legalmanbirthday:'',
      legalmantitle:'',
      legalmanexpertise:'',
      legalmanmobile:'',
      visitpv:'',
      following:'',
      roomarea:'',
      storearea:'',
      showarea:'',
      repairarea:'',
      teacharea:'',
      publicarea:'',
      allcollection:'',
      rarecollection:'',
      displaycollection:'',
      loancollection:'',
      staffnum:'',
      officialnum:'',
      specializedtitle:'',
      allseniortitle:'',
      intertitle:'',
      volunteer:'',
      mainexhibition1:'',
      mainexhibition2:'',
      mainexhibition3:'',
      tempexhibition1:'',
      tempexhibition2:'',
      tempexhibition3:'',
      education1:'',
      education2:'',
      education3:'',
      visitor1:'',
      visitor2:'',
      visitor3:'',
      underagevisitor1:'',
      underagevisitor2:'',
      underagevisitor3:'',
      overseasvisitor1:'',
      overseasvisitor2:'',
      overseasvisitor3:'',
      financialallocation1:'',
      financialallocation2:'',
      financialallocation3:'',
      businessincome1:'',
      businessincome2:'',
      businessincome3:'',
      expenditure1:'',
      expenditure2:'',
      expenditure3:'',
      appform:''
    },
    museumid:'',
    meseum:false
  }

  inputChange(type,value){
    if (type === 'newmedia' || type === 'postaddress' || type === 'url' || type === 'legalmantitle' || type === 'legalmanexpertise'){
      value = encodeURIComponent(value)
    }
    this.setState({
      data:{...this.state.data,[type]: value}
    })
  }

  fixValue(value){
    const result = this.state.data[value]
    if(isNaN(Number(result,10))){
      message.error('所填数为数字')
      this.setState({
        data:{...this.state.data,[value]: ''}
      })
      return
    }

    if (result !== '' && result !== null && Number(result) < 0) {
      message.error('所填数为大于等于0')
      this.setState({
        data:{...this.state.data,[value]: ''}
      })
    }
  }

  isNumber(value) {
    return typeof value === "number" && isFinite(value) || /^\d+$/.test(value);
  }

  onSelect(){
    const params = {
      museumid:this.state.museumid
    }
    getbaseInfo(params).then(res=>{
      if (res.statecode === 0) {
        if (res.records[0].annuals !=='' && res.records[0].annuals !== null) {
          res.records[0].annuals = res.records[0].annuals.split(',')
        }
        const data = JSON.parse(JSON.stringify(this.state.data))
        for (const key in data) {
          data[key] =  res.records[0][key]
        }
        this.setState({
          data:data
        })
      } else {
        message.error('未查询到博物馆信息');
      }
    })
  }


  onSubmit(){
    if (this.state.data['visitpv'] === ''){
      message.error('年均访问量应大于等于0')
      return false
    }
    if (this.state.data['following'] === ''){
      message.error('总关注人数应大于等于0')
      return false
    }
    if (this.state.data['roomarea'] === ''){
      message.error('建筑面积应大于等于0')
      return false
    }
    if (this.state.data['storearea'] === ''){
      message.error('库房面积应大于等于0')
      return false
    }
    if (this.state.data['showarea'] === ''){
      message.error('展厅面积应大于等于0')
      return false
    }
    if (this.state.data['repairarea'] === ''){
      message.error('实验修复室面积应大于等于0')
      return false
    }
    if (this.state.data['teacharea'] === '' ){
      message.error('教育空间面积应大于等于0')
      return false
    }
    if (this.state.data['publicarea'] === ''){
      message.error('公共服务空间面积应大于等于0')
      return false
    }
    if (this.state.data['allcollection'] === ''){
      message.error('藏品总数应大于等于0')
      return false
    }
    if (this.state.data['rarecollection'] === ''){
      message.error('三级以上珍贵文物数应大于等于0')
      return false
    }
    if (this.state.data['displaycollection'] === ''){
      message.error('年均展出藏品数应大于等于0')
      return false
    }
    if (this.state.data['loancollection'] === ''){
      message.error('年均外借藏品数应大于等于0')
      return false
    }
    if (this.state.data['staffnum'] === ''){
      message.error('总人数应大于等于0')
      return false
    }
    if (this.state.data['officialnum'] === '' ){
      message.error('在编人数应大于等于0')
      return false
    }
    if (this.state.data['specializedtitle'] === ''){
      message.error('专业人员数应大于等于0')
      return false
    }
    if (this.state.data['allseniortitle'] === '' ){
      message.error('高级职称人数应大于等于0')
      return false
    }
    if (this.state.data['intertitle'] === ''){
      message.error('中级职称人数应大于等于0')
      return false
    }
    if (this.state.data['volunteer'] === ''){
      message.error('志愿者人数应大于等于0')
      return false
    }
    if (this.state.data['mainexhibition1'] === '' || this.state.data['mainexhibition2'] === '' || this.state.data['mainexhibition3'] === ''){
      message.error('基本陈列数应大于等于0')
      return false
    }
    if (this.state.data['tempexhibition1'] === '' || this.state.data['tempexhibition1'] === '' || this.state.data['tempexhibition1'] === ''){
      message.error('临时展览数应大于等于0')
      return false
    }
    if (this.state.data['education1'] === '' || this.state.data['education2'] === '' || this.state.data['education3'] === ''){
      message.error('教育活动数应大于等于0')
      return false
    }
    if (this.state.data['visitor1'] === '' || this.state.data['visitor2'] === '' || this.state.data['visitor3'] === ''){
      message.error('观众数（万人次）应大于等于0')
      return false
    }
    if (this.state.data['underagevisitor1'] === '' || this.state.data['underagevisitor2'] === '' || this.state.data['underagevisitor3'] === ''){
      message.error('青少年观众（人次）应大于等于0')
      return false
    }
    if (this.state.data['overseasvisitor1'] === '' || this.state.data['overseasvisitor2'] === '' || this.state.data['overseasvisitor3'] === ''){
      message.error('海外观众（人次）应大于等于0')
      return false
    }
    if (this.state.data['financialallocation1'] === '' || this.state.data['financialallocation2'] === '' || this.state.data['financialallocation3'] === ''){
      message.error('财政拨款应大于等于0')
      return false
    }
    if (this.state.data['businessincome1'] === '' || this.state.data['businessincome2'] === '' || this.state.data['businessincome3'] === ''){
      message.error('经营性收入应大于等于0')
      return false
    }
    if (this.state.data['expenditure1'] === '' || this.state.data['expenditure2'] === '' || this.state.data['expenditure3'] === ''){
      message.error('年度支出应大于等于0')
      return false
    }
    Modal.confirm({
      content: '确认保存数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler()
      }
    })
  }

  downloads(file){
    window.location.href = file
  }

  onSubmitHandler(type=''){
    savebaseingo(this.state.data).then(res=>{
      if(res.statecode === 0) {
        this.props.refreshMenu(true)
        message.success('保存成功');
        this.props.refreshMenu(true)
        if (type === 'tz'){
          this.props.history.push({
            pathname: '/informationDeclaration/museumbaseinfo/resource',
          });
        }
      } else {
        message.error(res.statemessage);
      }
    })
  }

  componentDidMount(){
    const type = getStorage('userList').clerklevel
    if (type != 8 && type != 9) {
      const museumid = store.getState().libraryid
      this.setState({
        museumid:museumid,
        meseum:true
      },()=>{
        this.onSelect()
      })
    } else {
      this.onSelect()
    }
    store.subscribe(() => {
      const state = store.getState()
      if (state.libraryname){
        const museumid = store.getState().libraryid
        this.setState({
          museumid:museumid,
          meseum:true
        },()=>{
          this.onSelect()
        })
      }
    })
  }

  render(){
    return (
      <div className={this.state.meseum?'store-manage-list-new base-info  base-infodisabled':'store-manage-list-new base-info'}>
        <div className='shenhe-block'>
          {this.state.data.appform && this.state.data.appform!=='' &&
              <div className='shenhe-item' style={{color:'#1e9fff',textAlign:'right',fontSize:'16px',fontWeight:'bold',cursor:'pointer'}} onClick={()=>{this.downloads(this.state.data.appform)}}>
                博物馆定级评估申请书
              </div>
          }
          <div className='shenhe-item shenhe-itemblock'>
            <span>博物馆名称：</span>
            <span>{this.state.data.name}</span>
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>行政区域：</span>
            <span>{this.state.data.district}</span>
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>博物馆性质：</span>
            <span>{this.state.data.nature}</span>
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>拟申请等级：</span>
            <span>{this.state.data.applylevel}</span>
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>现有等级：</span>
            <span>{this.state.data.level}</span>
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>现有等级评定时间： </span>
            <CDatePicker disabled={this.state.meseum} value={this.state.data.levelingtime} onChange={(value)=>{this.inputChange('levelingtime',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>举办者： </span>
            <CInput disabled={this.state.meseum} value={this.state.data.holder} onChange={(value)=>{this.inputChange('holder',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>主管部门： </span>
            <CInput disabled={this.state.meseum} value={this.state.data.authority} onChange={(value)=>{this.inputChange('authority',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>全部或主要资金来源： </span>
            <CRadio disabled={this.state.meseum}
                    value={this.state.data.funds}
                    options={this.state.optionlist}
                    onChange={(value)=>{this.inputChange('funds',value)}}
            />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>隶属层级： </span>
            <CSelect disabled={this.state.meseum} value={this.state.data.belonglevelid} options={this.state.options}  onChange={(value)=>{this.inputChange('belonglevelid',value)}}  />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>题材类型： </span>
            <CSelect disabled={this.state.meseum} value={this.state.data.subjectid} options={this.state.tcoptions}  onChange={(value)=>{this.inputChange('subjectid',value)}}  />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>法人类型： </span>
            <CSelect disabled={this.state.meseum} value={this.state.data.corporateid} options={this.state.froptions}  onChange={(value)=>{this.inputChange('corporateid',value)}}  />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>法人登记机关： </span>
            <CInput disabled={this.state.meseum} value={this.state.data.regauthority} onChange={(value)=>{this.inputChange('regauthority',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>设立时间： </span>
            <CDatePicker disabled={this.state.meseum} value={this.state.data.createdate} onChange={(value)=>{this.inputChange('createdate',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>正式开放时间： </span>
            <CDatePicker disabled={this.state.meseum} value={this.state.data.firstdate} onChange={(value)=>{this.inputChange('firstdate',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>通讯地址： </span>
            <CInput disabled={this.state.meseum} value={decodeURIComponent(this.state.data.postaddress)} onChange={(value)=>{this.inputChange('postaddress',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>邮编： </span>
            <CInput disabled={this.state.meseum} value={this.state.data.postcode} onChange={(value)=>{this.inputChange('postcode',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>固定电话： </span>
            <CInput disabled={this.state.meseum} value={this.state.data.officephone} onChange={(value)=>{this.inputChange('officephone',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>传真： </span>
            <CInput disabled={this.state.meseum} value={this.state.data.fax} onChange={(value)=>{this.inputChange('fax',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>互联网址： </span>
            <CInput disabled={this.state.meseum} value={decodeURIComponent(this.state.data.url)} onChange={(value)=>{this.inputChange('url',value)}} />
          </div>
          <div className='shenhe-item shenhe-itemblock'>
            <span>主要社交媒体帐号(微博、微信等)： </span>
            <CInput disabled={this.state.meseum} value={decodeURIComponent(this.state.data.newmedia)} onChange={(value)=>{this.inputChange('newmedia',value)}} />
          </div>
        </div>
        <Card title="法定代表人">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box">
                <span>姓名： </span>
                <CInput disabled={this.state.meseum} value={this.state.data.legalmanname} onChange={(value)=>{this.inputChange('legalmanname',value)}} />
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box">
                <span>性别： </span>
                <CInput disabled={this.state.meseum} value={this.state.data.legalmansex} onChange={(value)=>{this.inputChange('legalmansex',value)}} />
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box">
                <span>出生年月： </span>
                <CInput disabled={this.state.meseum} value={this.state.data.legalmanbirthday} onChange={(value)=>{this.inputChange('legalmanbirthday',value)}} />
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box">
                <span>职称： </span>
                <CInput disabled={this.state.meseum} value={decodeURIComponent(this.state.data.legalmantitle)} onChange={(value)=>{this.inputChange('legalmantitle',value)}} />
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box">
                <span>学科专长： </span>
                <CInput disabled={this.state.meseum} value={decodeURIComponent(this.state.data.legalmanexpertise)} onChange={(value)=>{this.inputChange('legalmanexpertise',value)}} />
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box">
                <span>移动电话： </span>
                <CInput disabled={this.state.meseum} value={this.state.data.legalmanmobile} onChange={(value)=>{this.inputChange('legalmanmobile',value)}} />
              </div>
            </Col>
          </Row>
        </Card>
        <h3 style={{color:'red'}}>以下各项内容只能填写整数数字</h3>
        <Row gutter={16}>
          <Col className="gutter-row" span={12}>
            <div className="gutter-box gutter-box-big">
              <span>互联网年均访问量(次)： </span>
              <CInput  disabled={this.state.meseum} value={this.state.data.visitpv} onChange={(value)=>{this.inputChange('visitpv',value)}} onBlur={(value)=>{this.fixValue('visitpv')}}/>
            </div>
          </Col>
          <Col className="gutter-row" span={12}>
            <div className="gutter-box gutter-box-big">
              <span>主要社交媒体帐号总关注人数(人)： </span>
              <CInput  disabled={this.state.meseum} value={this.state.data.following} onChange={(value)=>{this.inputChange('following',value)}} onBlur={(value)=>{this.fixValue('following')}}/>
            </div>
          </Col>
        </Row>
        <Card title="博物馆面积（单位：平方米）">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>建筑面积： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.roomarea} onChange={(value)=>{this.inputChange('roomarea',value)}} onBlur={(value)=>{this.fixValue('roomarea')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>库房面积： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.storearea} onChange={(value)=>{this.inputChange('storearea',value)}} onBlur={(value)=>{this.fixValue('storearea')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>展厅面积： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.showarea} onChange={(value)=>{this.inputChange('showarea',value)}} onBlur={(value)=>{this.fixValue('showarea')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>实验修复室面积： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.repairarea} onChange={(value)=>{this.inputChange('repairarea',value)}} onBlur={(value)=>{this.fixValue('repairarea')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>教育空间面积： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.teacharea} onChange={(value)=>{this.inputChange('teacharea',value)}} onBlur={(value)=>{this.fixValue('teacharea')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>公共服务空间面积： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.publicarea} onChange={(value)=>{this.inputChange('publicarea',value)}} onBlur={(value)=>{this.fixValue('publicarea')}}/>
              </div>
            </Col>
          </Row>
        </Card>
        <Card title="藏品及文物（单位：件/套）">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>藏品总数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.allcollection} onChange={(value)=>{this.inputChange('allcollection',value)}} onBlur={(value)=>{this.fixValue('allcollection')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>三级以上珍贵文物数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.rarecollection} onChange={(value)=>{this.inputChange('rarecollection',value)}} onBlur={(value)=>{this.fixValue('rarecollection')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>年均展出藏品数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.displaycollection} onChange={(value)=>{this.inputChange('displaycollection',value)}} onBlur={(value)=>{this.fixValue('displaycollection')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>年均外借藏品数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.loancollection} onChange={(value)=>{this.inputChange('loancollection',value)}} onBlur={(value)=>{this.fixValue('loancollection')}}/>
              </div>
            </Col>
          </Row>
        </Card>
        <Card title="从业人员（单位：人）">
          <Row gutter={16}>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>总人数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.staffnum} onChange={(value)=>{this.inputChange('staffnum',value)}} onBlur={(value)=>{this.fixValue('staffnum')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>在编人数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.officialnum} onChange={(value)=>{this.inputChange('officialnum',value)}} onBlur={(value)=>{this.fixValue('officialnum')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>专业人员数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.specializedtitle} onChange={(value)=>{this.inputChange('specializedtitle',value)}} onBlur={(value)=>{this.fixValue('specializedtitle')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>高级职称人数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.allseniortitle} onChange={(value)=>{this.inputChange('allseniortitle',value)}}  onBlur={(value)=>{this.fixValue('allseniortitle')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>中级职称人数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.intertitle} onChange={(value)=>{this.inputChange('intertitle',value)}} onBlur={(value)=>{this.fixValue('intertitle')}}/>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div className="gutter-box gutter-box-big">
                <span>志愿者人数： </span>
                <CInput disabled={this.state.meseum}  value={this.state.data.volunteer} onChange={(value)=>{this.inputChange('volunteer',value)}} onBlur={(value)=>{this.fixValue('volunteer')}}/>
              </div>
            </Col>
          </Row>
        </Card>
        <Card title="开放情况">
          <Row className='zdytable'>
            <Col span={9}></Col>
            <Col span={5}>{this.state.data.annuals[0]}</Col>
            <Col span={5}>{this.state.data.annuals[1]}</Col>
            <Col span={5}>{this.state.data.annuals[2]}</Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>基本陈列数</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.mainexhibition1} onChange={(value)=>{this.inputChange('mainexhibition1',value)}} onBlur={(value)=>{this.fixValue('mainexhibition1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.mainexhibition2} onChange={(value)=>{this.inputChange('mainexhibition2',value)}} onBlur={(value)=>{this.fixValue('mainexhibition2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum} value={this.state.data.mainexhibition3} onChange={(value)=>{this.inputChange('mainexhibition3',value)}} onBlur={(value)=>{this.fixValue('mainexhibition3')}}/>
            </Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>临时展览数</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.tempexhibition1} onChange={(value)=>{this.inputChange('tempexhibition1',value)}} onBlur={(value)=>{this.fixValue('tempexhibition1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.tempexhibition2} onChange={(value)=>{this.inputChange('tempexhibition2',value)}} onBlur={(value)=>{this.fixValue('tempexhibition2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.tempexhibition3} onChange={(value)=>{this.inputChange('tempexhibition3',value)}} onBlur={(value)=>{this.fixValue('tempexhibition3')}}/>
            </Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>教育活动数</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.education1} onChange={(value)=>{this.inputChange('education1',value)}} onBlur={(value)=>{this.fixValue('education1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.education2} onChange={(value)=>{this.inputChange('education2',value)}} onBlur={(value)=>{this.fixValue('education2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.education3} onChange={(value)=>{this.inputChange('education3',value)}} onBlur={(value)=>{this.fixValue('education3')}}/>
            </Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>观众数（万人次）</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.visitor1} onChange={(value)=>{this.inputChange('visitor1',value)}} onBlur={(value)=>{this.fixValue('visitor1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.visitor2} onChange={(value)=>{this.inputChange('visitor2',value)}} onBlur={(value)=>{this.fixValue('visitor2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.visitor3} onChange={(value)=>{this.inputChange('visitor3',value)}} onBlur={(value)=>{this.fixValue('visitor3')}}/>
            </Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>青少年观众（人次）</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.underagevisitor1} onChange={(value)=>{this.inputChange('underagevisitor1',value)}} onBlur={(value)=>{this.fixValue('underagevisitor1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.underagevisitor2} onChange={(value)=>{this.inputChange('underagevisitor2',value)}} onBlur={(value)=>{this.fixValue('underagevisitor2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.underagevisitor3} onChange={(value)=>{this.inputChange('underagevisitor3',value)}} onBlur={(value)=>{this.fixValue('underagevisitor3')}}/>
            </Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>海外观众（人次）</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.overseasvisitor1} onChange={(value)=>{this.inputChange('overseasvisitor1',value)}} onBlur={(value)=>{this.fixValue('overseasvisitor1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.overseasvisitor2} onChange={(value)=>{this.inputChange('overseasvisitor2',value)}} onBlur={(value)=>{this.fixValue('overseasvisitor2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.overseasvisitor3} onChange={(value)=>{this.inputChange('overseasvisitor3',value)}} onBlur={(value)=>{this.fixValue('overseasvisitor3')}}/>
            </Col>
          </Row>
        </Card>
        <Card title="年度财务收支（万元）">
          <Row className='zdytable'>
            <Col span={9}></Col>
            <Col span={5}>{this.state.data.annuals[0]}</Col>
            <Col span={5}>{this.state.data.annuals[1]}</Col>
            <Col span={5}>{this.state.data.annuals[2]}</Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>财政拨款</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.financialallocation1} onChange={(value)=>{this.inputChange('financialallocation1',value)}} onBlur={(value)=>{this.fixValue('financialallocation1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.financialallocation2} onChange={(value)=>{this.inputChange('financialallocation2',value)}} onBlur={(value)=>{this.fixValue('financialallocation2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.financialallocation3} onChange={(value)=>{this.inputChange('financialallocation3',value)}} onBlur={(value)=>{this.fixValue('financialallocation3')}}/>
            </Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>经营性收入</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.businessincome1} onChange={(value)=>{this.inputChange('businessincome1',value)}} onBlur={(value)=>{this.fixValue('businessincome1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.businessincome2} onChange={(value)=>{this.inputChange('businessincome2',value)}} onBlur={(value)=>{this.fixValue('businessincome2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.businessincome3} onChange={(value)=>{this.inputChange('businessincome3',value)}} onBlur={(value)=>{this.fixValue('businessincome3')}}/>
            </Col>
          </Row>
          <Row className='zdytable'>
            <Col span={9}>年度支出</Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.expenditure1} onChange={(value)=>{this.inputChange('expenditure1',value)}} onBlur={(value)=>{this.fixValue('expenditure1')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.expenditure2} onChange={(value)=>{this.inputChange('expenditure2',value)}} onBlur={(value)=>{this.fixValue('expenditure2')}}/>
            </Col>
            <Col span={5}>
              <CInput disabled={this.state.meseum}  value={this.state.data.expenditure3} onChange={(value)=>{this.inputChange('expenditure3',value)}} onBlur={(value)=>{this.fixValue('expenditure3')}}/>
            </Col>
          </Row>
        </Card>
        {!this.state.meseum &&
            <div>
              <div style={{marginBottom:'10px',color:'red',textAlign:'center',fontSize:'16px'}}>上述数据如与“全国博物馆年度报告信息系统”信息不一致（因数据取整四舍五入造成数据不同除外），请提供说明文件，并在页面左侧导航栏“其它材料”菜单页面提交说明。</div>
              <Button type="primary" onClick={()=>{this.onSubmit()}} style={{marginTop:'20px'}}>保存</Button>
            </div>
        }
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Legal);

